// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
/*import "@hotwired/turbo-rails"
import "controllers"*/
import ReactOnRails from 'react-on-rails';

//import HelloWorld from '../bundles/HelloWorld/components/HelloWorldServer';
import Test from "../bundles/ror_components/Test.jsx";
import LeftNav from '../bundles/ror_components/LeftNav.jsx';
import HeaderSupport from "../bundles/ror_components/HeaderSupport.jsx";
import Signup from "../bundles/ror_components/Signup.jsx";
import Login from "../bundles/ror_components/Login.jsx";
import WorkspaceSettings from "../bundles/ror_components/WorkspaceSettings.jsx";
import Paginator from "../bundles/ror_components/Paginator.jsx";
import Payments from "../bundles/ror_components/Payments.jsx";
import Invoices from "../bundles/ror_components/Invoices.jsx";
import Customers from "../bundles/ror_components/Customers.jsx";
import Customer from "../bundles/ror_components/Customer.jsx";
import Payment from "../bundles/ror_components/Payment.jsx";
import Dashboard from "../bundles/ror_components/Dashboard.jsx";

// Re-render and unmount components as Turbo replaces page content. Without
// this, components only mount reliably after a full browser reload.
ReactOnRails.setOptions({ turbo: true });

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  //HelloWorld,
  Test,
  LeftNav,
  HeaderSupport,
  Signup,
  Login,
  WorkspaceSettings,
  Paginator,
  Payments,
  Invoices,
  Customers,
  Customer,
  Payment,
  Dashboard
});
